import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CurrentSelection, Customer, Equipment, JobSite, SelectionLists } from '../../../app/entities';
import { AppService } from '../../../app/app.service';
import { LoadingService } from '../../../app/shared/services/loading.service';
import { UserService } from '../../../app/shared/services/user.service';
import { TranslateService } from '../../../app/translate';
import { ManageEquipmentService } from '../manage-equipment/manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-equipment-status-popup',
  templateUrl: './equipment-status-popup.component.html',
  styleUrls: ['./equipment-status-popup.component.scss']
})
export class EquipmentStatusPopupComponent implements OnInit {

  translateSubscription: Subscription;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  userLanguage = 'english';
  isloading = true;


  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = '';
  _selectedEquipment: Equipment = new Equipment();
  selectedJobsite: JobSite;
  equipmentSelected: boolean;

  
  SelectedStatus:number;
  constructor(
    public dialogRef: MatDialogRef<EquipmentStatusPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _loading: LoadingService,
    private _appService: AppService,
    private _router: Router,
    private _translate: TranslateService,
    private _userService: UserService,private _notification: NotificationsService,
    private ref: ChangeDetectorRef, private _equipmentService: ManageEquipmentService,
  ) { }

  ngOnInit() {
    this.isloading = true;
    const customers = this._appService.getCustomerListForSelection(1, 10000);
    const jobsites = this._appService.getJobSiteListForSelection(1, 10000);
    const equipments = this._appService.getEquipmentListForSelection(1, 10000);

    Observable.forkJoin([customers, jobsites, equipments]).subscribe(results => {
      this._dropDownLists.customerList = results[0];
      this._dropDownListsFiltered.customerList = results[0];
      this._dropDownLists.jobSiteList = results[1];
      this._dropDownLists.equipmentList = results[2];
      this._loading.finishedLoading();
      this.isloading = false;
    });
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
}

customerChanged(event: any): void {
  const customer: Customer = event.value;
  if (!customer) return;
  this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
  this._currentSelection.jobSite = new JobSite();
  this._dropDownListsFiltered.equipmentList = [];
  this._currentSelection.equipment = new Equipment();
  this.equipmentSelected = false;
}

jobsiteChanged(event: any): void {
  const jobsite: JobSite = event.value;
  if (!jobsite) return;
  this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId === jobsite.Id);
  this._currentSelection.equipment = new Equipment();
  this.equipmentSelected = false;
}

equipmentChanged(event: any): void {
  this._selectedEquipment.Id = event.value.Id;
  this._selectedEquipment.JobSiteId = event.value.JobSiteId;
  this._selectedEquipment.Serial = event.value.Serial;
  this._selectedEquipment.Unit = event.value.Unit;
  this._selectedEquipment.FamilyId=event.value.FamilyId;

  this.equipmentSelected = true;

  this.GetEquipmentStatus();
}

onNoClick() {
  this.dialogRef.close();
}


Translate(value: string): string {
  return this._translate.translateToLang(value, this.userLanguage);
}

GetEquipmentStatus(){
  this._equipmentService.getEquipmentStatus(this._selectedEquipment.Id).subscribe(res=>{
    this.SelectedStatus = res;
  })
}

UpdateEquipmentStatus(){
  this._equipmentService.UpdateEquipmentStatus(this._selectedEquipment.Id, this.SelectedStatus).subscribe(res=>{
    if(res==true){
      this._notification.success("Sucessfully update the Equipment Status");
    }else{
      this._notification.error("Failed to update the Equipment Status");
    }
  })
}




}
